import {createUseStyles} from 'react-jss'

export const useStyles = createUseStyles({
    '@global': {
        "#cover-spin": {
            "position": "fixed",
            "width": "100%",
            "left": "0",
            "right": "0",
            "top": "0",
            "bottom": "0",
            "backgroundColor": "rgba(255, 255, 255)",
            "zIndex": "9999"
        },
        "#cover-spin img": {
            "display": "block",
            "position": "absolute",
            "left": "48%",
            "top": "40%",
            "width": "200px",
            "height": "200px",
            "borderTopColor": "transparent"
        },
        body: {
            margin: 0,
            '& .login.login-with-news-feed .news-feed, .register.register-with-news-feed .news-feed': {
                position: "relative"
            },
            '&.login.login-with-news-feed .news-caption, .register.register-with-news-feed .news-caption': {
                position: "relative",
                background: "transparent"
            },
            '& .register-with-news-feed .register-container': {
                background: 'white',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: 'auto'
            },
            '& .page-header-fixed': {
                paddingTop: "0px"
            },
            '& .login.login-with-news-feed .login-header, .register.register-with-news-feed .register-header': {
                fontSize: "inherit",
                padding: "60px 0px 0px 60px"
            }
        },
    }
})